export default "__VITE_ASSET__MnaD2I25__"